import { styled } from '@mui/material/styles';
import styledComponents from 'styled-components';
import { colors } from 'Constants/Colors';

const drawerWidth = 450;

export const Main = styled('main', {
  shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
  flexGrow: 1,
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  minHeight: '100vh',
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

export const drawerStyle = {
  width: drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    background: colors.BLUE_GRAY,
    width: drawerWidth,
    boxSizing: 'border-box',
  },
};

export const boxStyle = { display: 'flex', background: colors.BLUE_GRAY };

export const HeaderContainer = styledComponents.div`
  width: 100%;
  height: 9vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors.BLACK};
  color: ${colors.WHITE};
  font-family: quicksand;
  font-weight: bold;
  font-size: 1.5rem;
`;

export const FloatingBackContainer = styledComponents.div`
  position: absolute;
  left: 1vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  color: ${colors.WHITE};
  font-family: quicksand;
  font-weight: bold;
  font-size: 1.25rem;
  cursor: pointer;
  padding: 0.5rem;
`;

export default {
  Main,
  drawerStyle,
  boxStyle,
  HeaderContainer,
  FloatingBackContainer,
};
